<!--
 * @Author: hanhaotian
 * @Date: 2020-06-05 13:28:38
 * @LastEditTime: 2020-06-05 14:21:59
 * @LastEditors: yimengqi
 * @Description: 
 * @输出一段不带属性的自定义信息
--> 
<template>
  <div id="page-specConfig">
    <div class="main">
      <div class="tab-wrapper">
        <div class="tabItem">媒体监测任务</div>
      </div>
      <div class="operate-line">
        <div class="left">
          <Input v-model="taskKey" placeholder="输入任务名称" style="width: 200px;margin-right: 10px"  size="large" @keyup.enter.native="getTaskListInfo"/>
          <Button type="primary" @click="getTaskListInfo">查找</Button>
        </div>
        <div class="btn-new" @click="addNewTask" :class="{'disabled':!enable_create}">
          <span class="btn-new-text">新建任务</span>
        </div>
      </div>
      
      <table class="table-task" cellspacing="0" cellpadding="0" border="0">
        <thead class="table-head">
          <tr align="center">
            <th>名称</th>
            <th>媒体监测任务状态</th>
            <th>群组监测任务状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody class="table-body">
          <tr v-for="(item,i) in tableList" :key="i">
            <td>{{item.name}}</td>
            <td>
              <div>
                <i-switch
                  v-model="item.mediaState"
                  @on-change="changeState(item.id)"
                  class="btn-switch"
                ></i-switch>
              </div>
            </td>
            <td>{{item.groupState}}</td>
            <td>
              <div class="table-operations">
                <span
                  class="btn-operation btn-change"
                  :class="{'disabled':!enable_update}"
                  @click="changeTask(item.id)"
                >任务变更</span>
                <span
                  class="btn-operation btn-set"
                  :class="{'disabled':!enable_warn}"
                  @click="getSetAlertInfo(item.id)"
                >预警设置</span>
                <span
                  class="btn-operation btn-del"
                  :class="{'disabled':!enable_delete}"
                  @click="delTask(item.id)"
                >删除任务</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="page-wrapper" v-show="isShowPage" style="margin:30px">
        <Page
            :total="task_total"
            :page-size="pageSize"
            :current="currentPage"
            @on-change="changePage"
            show-total
            class="page"
        />
      </div>
    </div>
    <!-- 新建任务模态框 ----------------------------------------------------------------------->
    <div class="modal-mask" v-show="isShowModalAddNew">
      <div class="modal-wrapper">
        <div class="modal-header">
          <span class="modal-title" v-text="flag_modalAddNew==0?'新建媒体监测任务':'任务变更'"></span>
          <span class="icon-close" @click="cancelAddNewTask"></span>
        </div>
          <div class="modal-content">
            <Row :gutter="16" style="margin-top:15px" class="row-taskName">
              <Col span="5" class="col-l">
                <span>任务名称</span>
              </Col>
              <Col span="19" class="col-r">
                <input
                  type="text"
                  class="input-style input-name"
                  placeholder="请输入10个字符以内的任务名称"
                  v-model="newTaskData.name"
                  maxlength="10"
                />
              </Col>
            </Row>
            <Row :gutter="16" style="margin-top:15px" class="row-mainKeywords">
              <Col span="5" class="col-l">
                <span>主关键词</span>
              </Col>
              <Col span="19" class="col-r">
                <input
                  type="text"
                  class="input-style input-mainKeywords"
                  placeholder="若存在多个关键词，请用逗号分隔"
                  v-model="newTaskData.mainKeywords"
                  @input="changeComma('mainKeywords',500)"
                />
              </Col>
            </Row>
            <Row :gutter="16" style="margin-top:15px" class="row-secondKeywords">
              <Col span="5" class="col-l">
                <span>副关键词</span>
              </Col>
              <Col span="19" class="col-r">
                <div class="textarea-secondKeywords-wrapper">
                  <textarea
                    type="text"
                    class="input-style textarea-secondKeywords"
                    placeholder="若存在多个关键词，请用逗号分隔"
                    v-model="newTaskData.secondKeywords"
                    @input="changeComma('secondKeywords',500)"
                  ></textarea>
                  <span
                    ref="textarea_secondKeywords_count"
                    class="textarea-secondKeywords-count"
                  >{{newTaskData.secondKeywords.length}}/500</span>
                </div>
              </Col>
            </Row>
            <Row :gutter="16" style="margin-top:15px" class="row-exclWords">
              <Col span="5" class="col-l">
                <span>排除词</span>
              </Col>
              <Col span="19" class="col-r">
                <input
                  type="text"
                  class="input-style input-exclWords"
                  placeholder="若存在多个排除词，请用逗号分隔(选填)"
                  v-model="newTaskData.exclWords"
                  @input="changeComma('exclWords')"
                />
              </Col>
            </Row>
            <Row :gutter="16" style="margin-top:15px" class="row-classifyByCustom">
              <Col span="5" class="col-l">
                <span>自定义分类</span>
              </Col>
              <Col span="19" class="col-r">
                <div class="wrapper-add" v-for="(items,index) in newTaskData.classifyByCustomList" :key="index">
                  <div class="wrapper-add-l">
                    <input type="text" class="input-classifyByCustom-name" ref="inputClassifyByCustomName" v-model="items.name" placeholder="分类名称" @input="reset(index,'inputClassifyByCustomName')"/>
                    <Select v-model="items.type" style="width:100px" class="select-classifyByCustom" placeholder="分类类型">
                      <Option v-for="item in newTaskData.classifyByCustomOptions" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                    <input type="text" class="input-classifyByCustom-keywords" ref="inputClassifyByCustomKeywords" v-model="items.keywords" placeholder="关键词" @input="reset(index, 'inputClassifyByCustomKeywords')"/>
                  </div>
                  <div class="wrapper-add-r"  @click="deleteCustomTask(items,index)">删除</div>
                </div>
                <div class="add-operate">
                  <div style="display:inline-block" @click="addCustomTask">
                    <Icon type="md-add" size='20' />
                    <span>新增分类</span>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div class="modal-footer">
            <div class="btn-confirm" @click="submitAddNewTask">确认</div>
            <div class="btn-cancel" @click="cancelAddNewTask">取消</div>
          </div>
      </div>
    </div>
    <!-- 删除任务模态框 ----------------------------------------------------------------------->
    <div class="modal-mask" v-show="isShowModalDel">
      <div class="modal-delTask">
        <div class="icon-del-wrapper">
          <div class="icon-del"></div>
        </div>
        <div class="tip-wrapper">
          <p>删除任务后系统将清除相关数据</p>
          <p>
            确定删除
            <span style="color:red">{{delTaskName}}</span>任务吗
          </p>
        </div>
        <div class="modal-footer delete">
          <div class="btn-cancel" @click="isShowModalDel = false">取消</div>
          <div class="btn-confirm" @click="confirmDeleteTask">确认</div>
        </div>
      </div>
    </div>
    <!-- 预警设置模态框 ----------------------------------------------------------------------->
    <div class="modal-mask" v-show="isShowModalSetAlert">
      <div class="modal-wrapper">
        <div class="modal-header">
          <span class="modal-title">预警设置</span>
          <span class="icon-close" @click="handleCancelAlertSet"></span>
        </div>
        <div class="modal-content modal-setAlert-content">
          <Row :gutter="16" style="margin-top:32px" class="row-alertState">
            <Col span="6" class="col-l">
              <span>预警状态</span>
            </Col>
            <Col span="18" class="col-r">
              <span class="btn-switch" :class="{'btn-switch-on':!alertSetData.alertState}" @click="handleClickBtnSwitch(false)">关闭</span>
              <span class="btn-switch" :class="{'btn-switch-on':alertSetData.alertState}" @click="handleClickBtnSwitch(true)">开启</span>
            </Col>
          </Row>
          <Row :gutter="16" style="margin-top:15px" class="row-alertKeywords" v-show="isShowAlertItem">
            <Col span="6" class="col-l">
              <span>媒体监测任务预警关键词</span>
            </Col>
            <Col span="18" class="col-r">
              <input
                type="text"
                class="input-style input-alertKeywords"
                placeholder="若存在多个关键词，请用逗号分隔"
                v-model="alertSetData.keywords"
              />
            </Col>
          </Row>
          <Row
            :gutter="16"
            style="margin-top:15px"
            class="row-mailAddress"
            v-show="isShowAlertItem"
          >
            <Col span="6" class="col-l">
              <span>邮箱地址</span>
            </Col>
            <Col span="18" class="col-r">
              <div class="textarea-secondKeywords-wrapper">
                <textarea
                  type="text"
                  class="input-style textarea-mailAddress"
                  placeholder="多个邮箱地址之间，请用逗号分隔"
                  maxlength="300"
                  v-model="alertSetData.mailAddress"
                ></textarea>
                <span
                  ref="textarea_mailAddress_count"
                  class="textarea-secondKeywords-count"
                >{{alertSetData.mailAddress.length}}/300</span>
              </div>
            </Col>
          </Row>
          <Row :gutter="16" style="margin-top:15px" class="row-alertTime" v-show="isShowAlertItem">
            <Col span="6" class="col-l">
              <span>预警时间</span>
            </Col>
            <Col span="18" class="col-r">
              <div class="startTime">
                <TimePicker format="HH:mm" placeholder="开始" style="width:100px" v-model="alertSetData.alertTime_start" @on-change="changeAlertTime"></TimePicker>
              </div>
              <span>-</span>
              <div class="endTime">
                <TimePicker format="HH:mm" placeholder="结束" style="width:100px" v-model="alertSetData.alertTime_end" @on-change="changeAlertTime"></TimePicker>
              </div>
            </Col>
          </Row>
          <Row
            :gutter="16"
            style="margin-top:15px"
            class="row-alertFrequency"
            v-show="isShowAlertItem"
          >
            <Col span="6" class="col-l">
              <span>预警频率</span>
            </Col>
            <Col span="18" class="col-r">
              <Select
                v-model="alertSetData.alertFrequencySelection"
                style="width:200px"
                class="select-alertFrequency"
              >
                <Option
                  v-for="item in alertSetData.alertFrequencyOptions"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}</Option>
              </Select>
              <span class="alertOnce">预警一次</span>
            </Col>
          </Row>
        </div>
        <div class="modal-footer set-alert">
          <div class="btn-confirm" @click="submitAlertSetInfo">确认</div>
          <div class="btn-cancel" @click="handleCancelAlertSet">取消</div>
        </div>
      </div>
    </div>
    <!-- loading动画 --------------------------------------------------------------------------->
    <loading
      :isLoading="isLoadingTaskList||isSwichingMediaState||isSubmitingTaskData||isLoadingCurrentTaskData||isLoadingFrequencyOptionsData||isSubmitingAlertSetData||isDeletingTask"
    ></loading>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //是否正在获取任务列表数据
      isLoadingTaskList: false,
      //是否正在切换媒体监测状态
      isSwichingMediaState: false,
      //是否正在上传新建任务的数据
      isSubmitingTaskData: false,
      //是否正在获取当前任务数据
      isLoadingCurrentTaskData: false,
      //是否正在获取预警设置模态框数据
      isLoadingSetAlertData: false,
      //是否正在获取预警设置可选时间频率数据
      isLoadingFrequencyOptionsData: false,
      //是否正在上传预警设置的数据
      isSubmitingAlertSetData: false,
      //是否正在删除任务
      isDeletingTask: false,
      //表格数据
      tableList: [],
      //当前选中的任务id
      currentTaskId: null,
      //<新建任务>模态框的性质：新建(0)/编辑(1)
      flag_modalAddNew: 0,
      //控制<新建任务>模态框的显示
      isShowModalAddNew: false,
      //<新建任务>模态框中绑定的数据
      newTaskData: {
        name: "", //任务名称
        mainKeywords: "", //主关键词
        secondKeywords: "", //副关键词
        exclWords: "", //排除词
        classifyByCustom_name: "", //自定义分类--分类名称
        classifyByCustomSelection: "", //自定义分类--分类类型
        classifyByCustomOptions: [
          {
            value: 0,
            label: "全文包含"
          },
          {
            value: 1,
            label: "标题包含"
          },
          {
            value: 2,
            label: "正文包含"
          }
        ],
        //自定义分类--已添加
        classifyByCustomList: [],
        classifyByCustom_keywords: "" //自定义分类--关键词
      },
      //控制<删除任务>模态框的显示
      isShowModalDel: false,
      //<删除任务>模态框的显示的任务名称
      delTaskName: "",
      //控制<预警设置>模态框的显示
      isShowModalSetAlert: false,
      //<预警设置>模态框中绑定的数据
      alertSetData: {
        jobId: "",
        //预警状态:false-关闭，true-开启
        alertState: false,
        //预警关键词
        keywords: "",
        //邮箱地址
        mailAddress: "",
        //预警时间--开始时间
        alertTime_start: "", //"00:00"
        //预警时间--结束时间
        alertTime_end: "", //"23:59"
        //预警频率绑定的数据
        alertFrequencySelection: "",
        //预警频率下拉框绑定的可选数据
        alertFrequencyOptions: [],
        //预警规则是否已经创建过
        hasCreated: false
      },
      //<预警设置>模态框切换开启和关闭时控制其余项的显示
      isShowAlertItem: false,
      //权限-新建任务
      enable_create: false,
      //权限-任务变更
      enable_update: false,
      //权限-预警设置
      enable_warn: false,
      //权限-删除任务
      enable_delete: false,
      taskKey:'',
      task_total: 0,
      //当前展示的页码
      currentPage: 1,
      pageSize: 10,
      //是否展示分页：没有数据时隐藏
      isShowPage: true,
    };
  },
  created() {
    //获取任务列表数据
    this.getTaskListInfo();
  },
  mounted() {
    //获取新建任务、任务变更、预警设置、删除任务权限
    this.getAuthorities();
  },
  methods: {
    //获取上传报告和删除报告权限
    getAuthorities() {
      let authorites = this.getLocalStorage("authorities").split(",");
      //权限-新建任务
      this.enable_create = authorites.includes("job_config_create");
      //权限-任务变更
      this.enable_update = authorites.includes("job_config_update");
      //权限-预警设置
      this.enable_warn = authorites.includes("job_warn");
      //权限-删除任务
      this.enable_delete = authorites.includes("job_config_delete");
    },
    changePage(page) {
      //更新页码
      this.currentPage =  page;
      //查询舆情列表数据
      this.getTaskListInfo();
    },
    //获取任务列表数据
    getTaskListInfo() {
      if (this.isLoadingTaskList) return;
      this.isLoadingTaskList = true;
      this.$ajax({
        method: "get",
        url: "./job/list",
        params:{
          jobName: this.taskKey,
          "pageNo": this.currentPage,
          "pageSize": this.pageSize
        }
      })
        .then(res => {
          this.isLoadingTaskList = false;
          if (res.data.success) {
            //先清空
            this.tableList = [];
            let jobList = res.data.data.data || [];
            this.task_total = res.data.data.total;
            for (let i = 0; i < jobList.length; i++) {
              let item = {
                id: jobList[i].jobId, //任务id
                name: jobList[i].jobName, //任务名称
                firstKeyWords: jobList[i].firstKeyWords, //主关键词
                secondKeyWords: jobList[i].secondKeyWords, //副关键词
                excludeWords: jobList[i].excludeWords, //排除词
                mediaState: jobList[i].mediaStatus === 0 ? false : true, //群组任务启用状态，0：不启用，1启用
                groupState: jobList[i].status === 0 ? "关闭" : "开启"
              };
              this.tableList.push(item);
            }
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //获取当前任务模态框数据
    getCurrentTaskInfo() {
      if (this.isLoadingCurrentTaskData) return;
      this.isLoadingCurrentTaskData = true;
      this.$ajax({
        method: "get",
        url: "./job/detail",
        params: {
          jobId: this.currentTaskId
        }
      })
        .then(res => {
          this.isLoadingCurrentTaskData = false;
          if (res.data.success) {
            let data = res.data.data;
            this.currentTaskId = data.jobId;
            this.newTaskData.name = data.jobName;
            this.newTaskData.mainKeywords = data.firstKeyWords;
            this.newTaskData.secondKeywords = data.secondKeyWords;
            this.newTaskData.exclWords = data.excludeWords;
            this.newTaskData.classifyByCustomList = data.classifyDtoList.map(
              item => {
                let obj = {
                  id: Math.random(),
                  name: item.name,
                  type: item.type,
                  typeLable: (function(type) {
                    let label = "全文包含";
                    switch (type) {
                      case 0:
                        label = "全文包含";
                        break;
                      case 1:
                        label = "标题包含";
                        break;
                      case 2:
                        label = "正文包含";
                        break;
                      default:
                        break;
                    }
                    return label;
                  })(item.type),
                  keywords: item.keyWord
                };
                return obj;
              }
            );
            this.isShowModalAddNew = true;
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //获取预警设置模态框数据
    getSetAlertInfo(id) {
      if (!this.enable_warn) {
        this.$Message.error("未获得该功能权限");
        return;
      }
      this.currentTaskId = id;
      if (this.isLoadingSetAlertData) return;
      this.isLoadingSetAlertData = true;
      this.$ajax({
        method: "get",
        url: `./warning/detail/${this.currentTaskId}`
      })
        .then(res => {
          this.isLoadingSetAlertData = false;
          if (res.data.success) {
            let data = res.data.data;
            if (data === null) {
              //表示该预警规则未被创建
              this.alertSetData.hasCreated = false;
              this.isShowAlertItem = false;
            } else {
              //表示该预警规则已被创建
              this.alertSetData.jobId = data.jobId; //任务唯一id
              this.isShowAlertItem = this.alertSetData.alertState =
                data.status === 0 ? false : true; //启用状态 0：关闭 1：启用
              this.alertSetData.keywords = data.mediaKeyWords; //媒体预警关键词
              this.alertSetData.mailAddress = data.emails; //邮箱地址
              this.alertSetData.alertTime_start = data.warningBegin; //预警开始时间
              this.alertSetData.alertTime_end = data.warningEnd; //预警结束时间
              this.alertSetData.alertFrequencySelection = data.warningTypeId; //预警时间频率id
              this.alertSetData.hasCreated = true;
            }
            //获取预警规则可选时间频率数据
            this.getSetAlertFrequencyOptionsInfo();
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //获取预警规则可选时间频率数据
    getSetAlertFrequencyOptionsInfo() {
      if (this.isLoadingFrequencyOptionsData) return;
      this.isLoadingFrequencyOptionsData = true;
      this.$ajax({
        method: "get",
        url: "./warningtype/list"
      })
        .then(res => {
          this.isLoadingFrequencyOptionsData = false;
          if (res.data.success) {
            let list = res.data.data;
            //先清空
            this.alertSetData.alertFrequencyOptions = [];
            for (let i = 0; i < list.length; i++) {
              let item = {
                value: list[i].id,
                label: list[i].name
              };
              this.alertSetData.alertFrequencyOptions.push(item);
              this.isShowModalSetAlert = true;
            }
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //控制swtich开关以修改媒体监测任务状态
    changeState(id) {
      if (this.isSwichingMediaState) return;
      this.isSwichingMediaState = true;
      this.currentTaskId = id;
      //获取的是swich改变以后的状态
      let stateChanged = this.tableList.filter(item => item.id == id)[0]
        .mediaState;
      this.$ajax({
        method: "put",
        url: "./job/media/status",
        data: {
          jobId: id,
          mediaStatus: stateChanged ? 1 : 0 //媒体状态：0关闭，1开启
        }
      })
        .then(res => {
          this.isSwichingMediaState = false;
          if (res.data.success) {
            let name = this.tableList.filter(item => item.id == id)[0].name;
            let state = this.tableList.filter(item => item.id == id)[0]
              .mediaState
              ? "开启"
              : "关闭";
            this.$Message.success(`任务"${name}"的媒体监测任务状态已${state}`);
          } else {
            //重新获取任务列表数据
            this.getTaskListInfo();
            if (res.data.code === 405) {
              this.$Message.error("未获得该功能权限");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //点击<新建任务>按钮
    addNewTask() {
      if (!this.enable_create) {
        this.$Message.error("未获得该功能权限");
        return;
      }
      this.isShowModalAddNew = true;
      this.flag_modalAddNew = 0;
    },
    //点击<新建任务>模态框的<确定>按钮
    submitAddNewTask() {
      if (this.flag_modalAddNew === 0) {
        //如果是新增任务
        if (this.isSubmitingTaskData) return;
        this.isSubmitingTaskData = true;
        //先转化classifyDtoList的格式
        let classifyDtoList = [];
        for (let i = 0; i < this.newTaskData.classifyByCustomList.length; i++) {
          let item = {
            name: this.newTaskData.classifyByCustomList[i].name,
            type: this.newTaskData.classifyByCustomList[i].type,
            keyWord: this.newTaskData.classifyByCustomList[i].keywords
          };
          classifyDtoList.push(item);
        }
        //发送请求
        this.$ajax({
          method: "post",
          url: "./job/create",
          data: {
            jobName: this.newTaskData.name, //任务名称
            firstKeyWords: this.newTaskData.mainKeywords, //主关键词
            secondKeyWords: this.newTaskData.secondKeywords, //副关键词
            excludeWords: this.newTaskData.exclWords, //副关键词
            classifyDtoList
          }
        })
          .then(res => {
            this.isSubmitingTaskData = false;
            //如果存在res.data
            if (res.data.success) {
              this.$Message.success("任务新建成功");
              //清空模态框数据
              this.clearAllInModalAddNew();
              //关闭模态框
              this.isShowModalAddNew = false;
              //刷新表格数据
              this.getTaskListInfo();
            } else {
              if (res.data.code !== 405) {
                this.$Message.error("服务器错误");
              }
            }
          })
          .catch(err => {
            this.$Message.error("服务器错误");
            console.log(err);
          });
      } else {
        //如果是修改任务
        if (this.isSubmitingTaskData) return;
        this.isSubmitingTaskData = true;
        //先转化classifyDtoList的格式
        let classifyDtoList = [];
        this.newTaskData.classifyByCustomList.forEach((value,index) => {
            if(!value.name.trim()){
              this.$refs.inputClassifyByCustomName[index].style.borderColor = 'red'
            }
            if(!value.keywords.trim()){
              this.$refs.inputClassifyByCustomKeywords[index].style.borderColor = 'red'
            }
            if(!value.name.trim() || !value.keywords.trim()){
              this.isSubmitingTaskData = false
              this.$Message.error('请填写完整信息')
              return
            }
            let item = {
              name: value.name,
              type: value.type,
              keyWord: value.keywords
            }
            classifyDtoList.push(item);
        })
        if(!this.isSubmitingTaskData) return
        //发送请求
        this.$ajax({
          method: "put",
          url: "./job/update",
          data: {
            jobId: this.currentTaskId,
            jobName: this.newTaskData.name, //任务名称
            firstKeyWords: this.newTaskData.mainKeywords, //主关键词
            secondKeyWords: this.newTaskData.secondKeywords, //副关键词
            excludeWords: this.newTaskData.exclWords, //副关键词
            classifyDtoList
          }
        })
          .then(res => {
            this.isSubmitingTaskData = false;
            //如果存在res.data
            if (res.data.success) {
              this.$Message.success("任务修改成功");
              //清空模态框数据
              this.clearAllInModalAddNew();
              //关闭模态框
              this.isShowModalAddNew = false;
              //刷新表格数据
              this.getTaskListInfo();
            } else {
              if (res.data.code === 409) {
                this.$Message.error("关键词不能超过10个")
              } else if (res.data.code === 408) {
                this.$Message.error("关键词不能超过50个")
              } else if (res.data.code !== 405) {
                  this.$Message.error("服务器错误");
              }
            }
          })
          .catch(err => {
            this.$Message.error("服务器错误");
            console.log(err);
          });
      }
    },
    //点击<新建任务>模态框的<关闭>按钮
    cancelAddNewTask() {
      this.clearAllInModalAddNew();
      this.isShowModalAddNew = false;
    },
    //清空<新建任务>模态框的所有数据
    clearAllInModalAddNew() {
      this.newTaskData.name = this.newTaskData.mainKeywords = this.newTaskData.secondKeywords = this.newTaskData.exclWords = this.newTaskData.classifyByCustom_name = this.newTaskData.classifyByCustomSelection = this.newTaskData.classifyByCustom_keywords =
        "";
      this.newTaskData.classifyByCustomList = [];
    },
    //点击<新建任务>模态框的自定义分类的<添加>按钮
    // addCustomTask() {
    //   if (
    //     this.newTaskData.classifyByCustom_name.trim() === "" ||
    //     this.newTaskData.classifyByCustomSelection === "" ||
    //     this.newTaskData.classifyByCustom_keywords.trim() === ""
    //   ) {
    //     this.$Message.error("添加失败，请确保参数完整");
    //   } else {
    //     let item = {
    //       id: new Date().getTime(),
    //       name: this.newTaskData.classifyByCustom_name,
    //       type: this.newTaskData.classifyByCustomSelection, //分类类型：0全文包含,1标题包含，2正文包含
    //       typeLable: (function(param) {
    //         let typeLable = "全文包含";
    //         switch (param) {
    //           case 0:
    //             typeLable = "全文包含";
    //             break;
    //           case 1:
    //             typeLable = "标题包含";
    //             break;
    //           case 2:
    //             typeLable = "正文包含";
    //             break;
    //           default:
    //             break;
    //         }
    //         return typeLable;
    //       })(this.newTaskData.classifyByCustomSelection),
    //       keywords: this.newTaskData.classifyByCustom_keywords
    //     };
    //     this.newTaskData.classifyByCustomList.push(item);
    //     //添加之后自动清空输入框和下拉框的数据
    //     this.newTaskData.classifyByCustom_name = this.newTaskData.classifyByCustomSelection = this.newTaskData.classifyByCustom_keywords =
    //       "";
    //   }
    // },
    addCustomTask(){
      let that = this;
      that.newTaskData.classifyByCustomList.push({
        id: Math.random(),
        name: '',
        type: 0,
        typeLable: "全文包含",
        keywords: ''
      })
    },
    reset(index,name){
      let that = this;
      that.$refs[name][index].style.borderColor = '#d8d9dc';
      that.changeComma('classifyByCustomList',null,index)
    },
    //点击<新建任务>模态框的自定义分类的<删除>按钮
    deleteCustomTask(id,index) {
      // this.newTaskData.classifyByCustomList = this.newTaskData.classifyByCustomList.filter(
      //   item => item.id !== id
      // );
      let that = this;
      console.log(id)
      that.newTaskData.classifyByCustomList.splice(index,1);
    },
    changeComma(key,limit,index){
      let that = this;
      if(index || index === 0){
        that.newTaskData[key][index]['keywords'] = that.newTaskData[key][index]['keywords'].replace(/，|\、/gi, ",");
      }else{
        that.newTaskData[key] = that.newTaskData[key].replace(/，|\、/gi, ",");
        if(limit){
          if(that.newTaskData[key].split(",") && that.newTaskData[key].split(",").length > limit){
            this.$Message.error("test关键词不能超过" + limit +"个");
            let arr = this.newTaskData[key].split(",");
            arr.pop();
            this.newTaskData[key] = arr.join(",");
          }
        }
      }
      
    },
    //点击<任务变更>按钮
    changeTask(id) {
      if (!this.enable_update) {
        this.$Message.error("未获得该功能权限");
        return;
      }
      this.currentTaskId = id;
      let name = this.tableList.filter(item => item.id == id)[0].name;
      let status = this.tableList.filter(item => item.id == id)[0].mediaState;
      //如果媒体监测任务状态是<开启>，则不可以删除任务
      if (status) {
        this.$Message.error("请先关闭媒体监测任务状态");
        return;
      }
      this.getCurrentTaskInfo();
      this.flag_modalAddNew = 1; //修改为编辑任务模式
    },
    //点击<预警设置>模态框的确认按钮
    submitAlertSetInfo() {
      if (this.isSubmitingAlertSetData) return;
      this.isSubmitingAlertSetData = true;
      let method = "";
      let url = "";
      if (this.alertSetData.hasCreated) {
        //如果当前预警设置的hasCreated是true，则说明该预警设置已经创建过，因此url对应修改预警规则配置
        method = "put";
        url = "./warning/edit";
      } else {
        //如果当前预警设置的hasCreated是false，则说明该预警设置没有创建过，因此url对应新增预警规则配置
        method = "post";
        url = "./warning/info";
      }
      this.$ajax({
        method,
        url,
        data: {
          jobId: this.currentTaskId,
          status: this.alertSetData.alertState ? 1 : 0,
          mediaKeyWords: this.alertSetData.keywords,
          emails: this.alertSetData.mailAddress,
          warningBegin: this.alertSetData.alertTime_start,
          warningEnd: this.alertSetData.alertTime_end,
          warningTypeId: this.alertSetData.alertFrequencySelection
        }
      })
        .then(res => {
          this.isSubmitingAlertSetData = false;
          if (res.data.success) {
            this.$Message.success("预警规则保存成功");
            //关闭模态框并还原数据
            this.handleCancelAlertSet();
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //点击<删除任务>按钮
    delTask(id) {
      if (!this.enable_delete) {
        this.$Message.error("未获得该功能权限");
        return;
      }
      this.currentTaskId = id;
      this.delTaskName = this.tableList.filter(item => item.id == id)[0].name;
      let status = this.tableList.filter(item => item.id == id)[0].mediaState;
      //如果媒体监测任务状态是<开启>，则不可以编辑任务
      if (status) {
        this.$Message.error("请先关闭媒体监测任务状态");
        return;
      }
      this.isShowModalDel = true;
    },
    confirmDeleteTask() {
      if (this.isDeletingTask) return;
      this.isDeletingTask = true;
      this.$ajax({
        method: "delete",
        url: "./job/delete",
        data: this.$qs.stringify({
          jobId: this.currentTaskId
        }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(res => {
          this.isDeletingTask = false;
          if (res.data.success) {
            let delTaskName = this.tableList.filter(
              item => item.id == this.currentTaskId
            )[0].name;
            this.$Message.success(`已删除任务"${delTaskName}"`);
            //隐藏模态框
            this.isShowModalDel = false;
            //刷新表格
            this.getTaskListInfo();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //点击预警设置模态框<取消>按钮
    handleCancelAlertSet() {
      //先还原模态框数据
      this.alertSetData.jobId = this.alertSetData.keywords = this.alertSetData.mailAddress = this.alertSetData.alertTime_start = this.alertSetData.alertTime_end = this.alertSetData.alertFrequencySelection =
        "";
      this.alertSetData.alertState = this.alertSetData.hasCreated = false;
      this.alertSetData.alertFrequencyOptions = [];
      //关闭模态框
      this.isShowModalSetAlert = false;
    },
    //切换<预警设置>模态框预警状态按钮
    handleClickBtnSwitch(param) {
      this.isShowAlertItem = this.alertSetData.alertState = param;
    },
    //更改<预警设置>模态框预警时间
    changeAlertTime() {
      //如果结束时间大于开始时间，自动交换开始和结束时间
      let start = new Date("2019/6/13 " + this.alertSetData.alertTime_start);
      let end = new Date("2019/6/13 " + this.alertSetData.alertTime_end);
      if (end < start) {
        let temp = this.alertSetData.alertTime_start;
        this.alertSetData.alertTime_start = this.alertSetData.alertTime_end;
        this.alertSetData.alertTime_end = temp;
      }
    }
  },
  watch: {
  //   //新建任务--主关键词
  //   "newTaskData.mainKeywords": {
  //     handler(newVal, oldVal) {
  //       //禁止用户输入中文逗号
  //       this.newTaskData.mainKeywords = this.newTaskData.mainKeywords.replace(
  //         /，|\、/gi,
  //         ","
  //       );
  //       //禁止用户输入超过10个词
  //       if (
  //         this.newTaskData.mainKeywords.split(",").length > 10 &&
  //         this.newTaskData.mainKeywords.split(",")
  //       ) {
  //         this.$Message.error("主关键词不能超过10个");
  //         let arr = this.newTaskData.mainKeywords.split(",");
  //         arr.pop();
  //         this.newTaskData.mainKeywords = arr.join(",");
  //       }
  //     }
  //   },
  //   //新建任务--副关键词
  //   "newTaskData.secondKeywords": {
  //     handler(newVal, oldVal) {
  //       //禁止用户输入中文逗号和顿号
  //       this.newTaskData.secondKeywords = this.newTaskData.secondKeywords.replace(
  //         /(，|\、)/gi,
  //         ","
  //       );
  //       //禁止用户输入超过10个词
  //       if (
  //         this.newTaskData.secondKeywords.split(",").length > 10 &&
  //         this.newTaskData.secondKeywords.split(",")
  //       ) {
  //         this.$Message.error("副关键词不能超过10个");
  //         let arr = this.newTaskData.secondKeywords.split(",");
  //         arr.pop();
  //         this.newTaskData.secondKeywords = arr.join(",");
  //       }
  //     }
  //   },
  //   //新建任务--排除词
  //   "newTaskData.exclWords": {
  //     handler(newVal, oldVal) {
  //       //禁止用户输入中文逗号和顿号
  //       this.newTaskData.exclWords = this.newTaskData.exclWords.replace(
  //         /(，|\、)/gi,
  //         ","
  //       );
  //     }
  //   },
  //   //新建任务--自定义分类--关键词
  //   "newTaskData.classifyByCustom_keywords": {
  //     handler(newVal, oldVal) {
  //       //禁止用户输入中文逗号和顿号
  //       this.newTaskData.classifyByCustom_keywords = this.newTaskData.classifyByCustom_keywords.replace(
  //         /(，|\、)/gi,
  //         ","
  //       );
  //     }
  //   },
  //   //预警设置--关键词
    "alertSetData.keywords": {
      handler(newVal, oldVal) {
        //禁止用户输入中文逗号和顿号
        this.alertSetData.keywords = this.alertSetData.keywords.replace(
          /(，|\、)/gi,
          ","
        );
        //禁止用户输入超过10个词
        if (
          this.alertSetData.keywords.split(",").length > 10 &&
          this.alertSetData.keywords.split(",")
        ) {
          this.$Message.error("预警关键词不能超过10个");
          let arr = this.alertSetData.keywords.split(",");
          arr.pop();
          this.alertSetData.keywords = arr.join(",");
        }
      }
    },
    //预警设置--邮箱地址
    "alertSetData.mailAddress": {
      handler(newVal, oldVal) {
        //禁止用户输入中文逗号和顿号
        this.alertSetData.mailAddress = this.alertSetData.mailAddress.replace(
          /(，|\、)/gi,
          ","
        );
      }
    }
  }
};
</script>

<style lang="less">
@import "../../../style/common.less";
#page-specConfig {
  .input-placeholder;
  .btn-switch-blue;
  .main {
    width: 1160px;
    margin: 0 auto;
    margin-top: 20px;
    background-color: #fff;
    box-sizing: border-box;
    min-height: 1040px;
    padding: 25px 80px;
    box-shadow: 0 0 16px 0 #f3f4f7;
    .tab-wrapper {
      height: 55px;
      border-bottom: 1px solid #efeff4;
      .tabItem {
        width: 108px;
        line-height: 52px;
        float: left;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #333333;
        box-sizing: border-box;
        border-bottom: 3px solid #415af6;
      }
    }
    .operate-line{
      overflow: hidden;
      .left{
        float: left;
        margin-top: 20px;
      }
    }
    .btn-new {
      float: right;
      background: #415af6;
      border-radius: 4px;
      width: 153px;
      height: 40px;
      margin-top: 20px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      .btn-new-text {
        line-height: 40px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: -0.33px;
        &::before {
          display: inline-block;
          content: "";
          height: 15px;
          width: 15px;
          background: url("https://static.rong360.com/upload/png/51/86/5186be763e12f47350cdb189b5cd7146.png");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          vertical-align: middle;
          margin-right: 5px;
          margin-top: -4px;
        }
      }
      &.disabled {
        opacity: 0.7;
        cursor: not-allowed;
      }
    }
    .table-task {
      margin: 0 auto;
      margin-top: 15px;
      width: 997px;
      .table-head {
        line-height: 50px;
        background-color: #f8fafe;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        tr {
          th {
            border-top: 1px solid #efeff4;
          }
          th:first-of-type {
            border-left: 1px solid #efeff4;
          }
          th:last-of-type {
            border-right: 1px solid #efeff4;
          }
        }
      }
      .table-body {
        tr {
          border-bottom: 1px solid #efeff4;
          transition: all 0.3s ease-in;
          &:hover {
            background-color: #f0f8ff;
          }
          td {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #333333;
            letter-spacing: 0;
            line-height: 50px;
            border-bottom: 1px solid #efeff4;
          }
          td:first-of-type {
            border-left: 1px solid #efeff4;
          }
          td:last-of-type {
            border-right: 1px solid #efeff4;
          }
        }
        .table-operations {
          display: flex;
          justify-content: space-around;
          .btn-change::before {
              background: url("https://static.rong360.com/upload/png/3f/72/3f729ce51a4b296eadb5cfb0c70c9587.png");
          }
          .btn-set::before {
              background: url("https://static.rong360.com/upload/png/8d/3c/8d3c322c5ddd0824dc271d1e4dfc6b7f.png");
          }
          .btn-del::before {
              background: url("https://static.rong360.com/upload/png/76/d6/76d6c7c9a23ca15ae4b55266f9fe7cf9.png");
          }
          .btn-operation {
            cursor: pointer;
            &::before {
              display: inline-block;
              content: "";
              height: 16px;
              width: 16px;
              margin-right: 5px;
              margin-top: -2px;
              background-position: center;
              background-repeat: no-repeat;
              background-size: 100% 100%;
              vertical-align: middle;
            }
            &.disabled {
              cursor: not-allowed;
              color: #999;
              &::before {
                opacity: 0.5;
              }
            }
          }
        }
      }
    }
  }

  .modal-mask {
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 999;
    top: 0;
    left: 0;
    transition: all 0.3s ease-in;
    .modal-wrapper {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 500px;
      transform: translate(-50%, -50%);
      background: #fff;
      box-shadow: 0 0 30px 0 #c8c7cc;
      border-radius: 4px;
      padding-bottom: 50px;
      .modal-header {
        height: 60px;
        border-bottom: 1px solid #efeff4;
        text-align: left;
        padding-left: 27px;
        position: relative;
        .modal-title {
          line-height: 60px;
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #333333;
        }
        .icon-close {
          position: absolute;
          right: 28px;
          top: 50%;
          transform: translate(0, -50%);
          height: 20px;
          width: 20px;
          line-height: 60px;
          background: url("https://static.rong360.com/upload/png/6c/9c/6c9c09640ef8a6a010b1f3b69b0f94bf.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .modal-content {
        padding-right: 25px;
        &.modal-setAlert-content{
          padding-right: 15px;
          height: 349px;
        }
        .col-l {
          text-align: right;
          span {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #666666;
            letter-spacing: -0.33px;
          }
        }
        .col-r{
          .textarea-secondKeywords-wrapper{
              position: relative;
              .textarea-secondKeywords-count {
                position: absolute;
                bottom: 8px;
                right: 10px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #d8d9dc;
                letter-spacing: -0.29px;
              }
          }
          .input-style{
              width: 100%;
              border: 1px solid #d8d9dc;
              border-radius: 4px;
              outline: none;
              padding-left: 15px;
              line-height: 30px;
              transition: all 0.2s ease-in;
              &:focus {
                border: 1px solid #677bf8;
                border-color: #677bf8;
                box-shadow: 0 0 3px #677bf8;
              }
              &.input-name, &.input-mainKeywords, &.input-exclWords,&.input-alertKeywords {
                height: 30px;
              }
              &.textarea-secondKeywords,&.textarea-mailAddress {
                height: 150px;
                resize: none;
              }
          }
        }
        .row-classifyByCustom {
          .col-r {
            .wrapper-add {
              overflow: hidden;
              margin-bottom: 5px;
              .wrapper-add-l {
                float: left;
                height: 30px;
                width: 300px;
                .input-classifyByCustom-name,.input-classifyByCustom-keywords {
                  float: left;
                  height: 30px;
                  width: 100px;
                  border: 1px solid #d8d9dc;
                  outline: none;
                  padding-left: 15px;
                  line-height: 30px;
                }
                .input-classifyByCustom-name{
                  border-right: none;
                  border-radius: 4px 0 0 4px;
                }
                .input-classifyByCustom-keywords{
                  border-left: none;
                  border-radius: 0 4px 4px 0;

                }
                .select-classifyByCustom {
                  float: left;
                  height: 30px;
                  .ivu-select-selection {
                    border-radius: 0;
                    height: 30px;
                  }
                }
              }
              .wrapper-add-r {
                float: right;
                height: 30px;
                width: 60px;
                line-height: 30px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: red;
                letter-spacing: -0.29px;
                border: 1px solid #d8d9dc;
                border-radius: 2px;
                cursor: pointer;
                &:hover {
                  opacity: 0.8;
                }
              }
            }
            .add-operate{
              height: 30px;
              line-height: 30px;
              width: 300px;
              margin-top: 10px;
              color: #415af6;
              span{
                margin-left: 5px;
              }
            }
          }
        }
      }
    }
    .modal-footer {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        &.set-alert{
          margin-top: 40px;
        }
        &.delete{
          margin-top: 55px;
        }
        .btn-confirm {
          background: #415af6;
          margin-left: 20px;
          border-radius: 4px;
          height: 40px;
          line-height: 40px;
          width: 153px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #ffffff;
          letter-spacing: -0.33px;
          cursor: pointer;
          // transition: all 0.2s ease-in-out;
          &:hover {
            opacity: 0.8;
          }
        }
        .btn-cancel {
          color: #415af6;
          border: 1px solid #415af6;
          border-radius: 4px;
          height: 40px;
          line-height: 40px;
          width: 153px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          letter-spacing: -0.33px;
          margin-left: 15px;
          cursor: pointer;
          // transition: all 0.2s ease-in-out;
          &:hover {
            opacity: 0.8;
          }
        }
      }
  }
    .modal-delTask {
      position: absolute;
      left: 50%;
      height: 364px;
      width: 500px;
      transform: translate(-50%, 50%);
      background: #fff;
      box-shadow: 0 0 30px 0 #c8c7cc;
      border-radius: 4px;
      padding: 57px 90px;
      box-sizing: border-box;
      .icon-del-wrapper {
        display: flex;
        justify-content: center;
        .icon-del {
          height: 60px;
          width: 60px;
          background: url("https://static.rong360.com/upload/png/f0/9c/f09c7446efc39fcd2c164c02e4203339.png");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
      .tip-wrapper {
        margin-top: 32px;
        p {
          font-family: PingFangSC-Regular;
          font-size: 22px;
          color: #333333;
          letter-spacing: -0.45px;
          text-align: center;
          line-height: 32px;
        }
      }
    }
    .row-alertState {
      .col-r {
        span:first-child {
          border-radius: 4px 0 0 4px;
        }
        span:last-child {
          border-radius: 0 4px 4px 0;
        }
        .btn-switch {
          float: left;
          height: 26px;
          width: 96px;
          line-height: 26px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          letter-spacing: -0.29px;
          vertical-align: middle;
          border: 1px solid #d8d9dc;
          transition: all 0.3s ease-in;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
        .btn-switch-on {
          color: #fff;
          background-color: #415af6;
          border: none;
        }
      }
    }
    .row-alertTime {
      .col-r {
        display: flex;
        justify-content: flex-start;
        .input-alertTime {
          border: 1px solid #d8d9dc;
          border-radius: 4px;
          outline: none;
          width: 100px;
          height: 30px;
          text-indent: 0.3em;
        }
        span {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #333333;
          letter-spacing: -0.29px;
          margin-left: 10px;
          margin-right: 10px;
          line-height: 30px;
          font-weight: bold;
        }
      }
    }
    .row-alertFrequency {
      .col-r {
        .select-alertFrequency {
          border-radius: 4px;
          height: 30px;
          width: 162px;
          float: left;
          .ivu-select-dropdown-list {
            li {
              text-align: left;
            }
          }
        }
        .alertOnce {
          float: left;
          margin-left: 10px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #333333;
          letter-spacing: -0.29px;
          line-height: 30px;
        }
      }
    }
}
</style>
